/* eslint-disable no-console */
/* eslint-disable @reolink/general/disable-json-parse-method */
import $HeaderClientEntry from './entry-header';
import $FooterClientEntry from './entry-footer';
import './entry-layout';

const contextContent = document.getElementById('bff-context')?.innerText;
const fetchDataContent = document.getElementById('bff-fetch-data')?.innerText;

async function main(): Promise<void> {
    try {
        const context = contextContent ? JSON.parse(contextContent) : {};
        const fetchData = fetchDataContent ? JSON.parse(fetchDataContent) : null;
        const { meta } = context;
        if (meta) {
            const initTasks: Array<Promise<void>> = [];
            const { clientFeatures = {} } = meta;
            if (clientFeatures.useHeader !== false) {
                initTasks.push($HeaderClientEntry.onRenderClient(context, fetchData));
            }
            if (clientFeatures.useFooter !== false) {
                initTasks.push($FooterClientEntry.onRenderClient(context, fetchData));
            }
            await Promise.all(initTasks);
        }
        else {
            await Promise.all([
                $HeaderClientEntry.onRenderClient(context, fetchData),
                $FooterClientEntry.onRenderClient(context, fetchData),
            ]);
        }
    }
    finally {
        const cleaner = (): void => {
            if (contextContent) {
                document.getElementById('bff-context')?.remove();
            }
            if (fetchDataContent) {
                document.getElementById('bff-fetch-data')?.remove();
            }
        };
        if (typeof requestIdleCallback !== 'undefined') {
            requestIdleCallback(cleaner);
        }
        else {
            setTimeout(cleaner);
        }
    }
}

main().catch((e) => {
    console.error('Create app failed', e);
});
